// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import applicationChangeRequestEntity from './entities/application-change-request.json';
import applicationChangeRequestMenu from '../pages/application-change-request/menu.json';
import applicationChangeRequestFullForm from '../pages/application-change-request/forms/full.json';
import applicationChangeRequestContextForm from '../pages/application-change-request/forms/context.json';
import applicationChangeRequestMiniForm from '../pages/application-change-request/forms/mini.json';
import applicationChangeRequestLookupForm from '../pages/application-change-request/forms/lookup.json';
import applicationChangeRequestTableView from '../pages/application-change-request/views/table.json';
import applicationChangeRequestCardsView from '../pages/application-change-request/views/cards.json';
import applicationChangeRequestDashboardView from '../pages/application-change-request/views/dashboard.json';

/** Тип запису «Запит на зміну» зі сторінками пакета: меню, форми та подання з pages/application-change-request/. */
export const applicationChangeRequestDefinition: IRecordTypeDefinition = {
  ...applicationChangeRequestEntity,
  views: assembleViewSet({
      table: applicationChangeRequestTableView,
      cards: applicationChangeRequestCardsView,
      dashboard: applicationChangeRequestDashboardView,
  }),
  form: applicationChangeRequestFullForm,
  forms: { full: applicationChangeRequestFullForm, context: applicationChangeRequestContextForm, mini: applicationChangeRequestMiniForm, lookup: applicationChangeRequestLookupForm },
  menu: applicationChangeRequestMenu,
} as IRecordTypeDefinition;
